'use client';

import { createPortal } from 'react-dom';

import { PortalProps } from './types';
import { ReactPortal, useEffect, useState } from 'react';
import { overlayId } from '../wrapper';

export function Portal({ children }: PortalProps): ReactPortal | null {
	const [mounted, setMounted] = useState(false);

	let overlayRoot: Element | null = null;
	if (typeof window !== 'undefined') {
		overlayRoot = document.querySelector(`.${overlayId}`);
	}

	useEffect(() => {
		setMounted(true);

		return () => setMounted(false);
	}, []);

	return mounted && overlayRoot ? createPortal(children, overlayRoot) : null;
}
